import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Input } from '../../../../../components';
import {
  getVendorEventsByEvent,
  onSearchVendorsEvent,
} from '../../../../../core/vendor-events/action';
import VendorEventsTable from './VendorEventsTable';

function ManageVendors({ event }) {
  const dispatch = useDispatch();
  const { eventList, filteredVendorsEvent } = useSelector((store) => store.vendorEvents);
  const [inputSearch, setInputSearch] = useState('');

  useEffect(() => {
    if (!event?.id) return;
    dispatch(getVendorEventsByEvent(event.id));
  }, [dispatch, event]);

  const onSearch = (e) => {
    setInputSearch(e.target.value);
    dispatch(onSearchVendorsEvent(e.target.value));
  };

  const getUsersList = () =>
    (filteredVendorsEvent && filteredVendorsEvent.length > 0) || inputSearch.trim() !== ''
      ? filteredVendorsEvent
      : eventList;

  return (
    <>
      <Grid item xs={12} /* style={inputStyles} */>
        <Input
          type="text"
          value={inputSearch}
          style={{ width: '68vw', marginTop: 4 }}
          placeholder="Typing some here..."
          onChange={onSearch}
        />
      </Grid>
      {getUsersList()?.length ? (
        <VendorEventsTable eventList={getUsersList()} />
      ) : (
        <p>There are no applications results for this event</p>
      )}
    </>
  );
}

ManageVendors.propTypes = {
  event: PropTypes.instanceOf(Object).isRequired,
};

export default ManageVendors;
